import { Badge } from "@/components/ui/badge";

export default function UserTable({ users, renderActions, emptyText }) {
  if (users.length === 0) return <p className="text-sm text-muted-foreground py-6">{emptyText}</p>;
  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[620px] text-sm">
        <thead className="border-b border-border text-left text-xs uppercase tracking-wider text-muted-foreground">
          <tr>{["Nama", "Email / Username", "Departemen", "Login Terakhir", "Role", "Aksi"].map((label) => <th key={label} className="py-3 pr-4 font-medium">{label}</th>)}</tr>
        </thead>
        <tbody className="divide-y divide-border">
          {users.map((account) => (
            <tr key={account.id}>
              <td className="py-3 pr-4 font-medium">{account.name}</td>
              <td className="py-3 pr-4 text-muted-foreground"><div>{account.email || "—"}</div>{account.username && <div className="text-xs">@{account.username}</div>}</td>
              <td className="py-3 pr-4 text-muted-foreground">{account.department || "Akses pribadi"}</td>
              <td className="py-3 pr-4 text-muted-foreground">{account.last_login ? new Date(account.last_login).toLocaleString("id-ID") : "Belum tercatat"}</td>
              <td className="py-3 pr-4"><Badge variant={account.role === "admin" ? "default" : "outline"} className="rounded-none">{account.role}</Badge></td>
              <td className="py-3"><div className="flex gap-2">{renderActions(account)}</div></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
